var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "url(#pattern0_6571_3438)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_6571_3438",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6571_3438",
    transform: "scale(0.00666667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6571_3438",
    width: 150,
    height: 150,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWCAMAAAAL34HQAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAzUExURQAAAL8gML8gMMUgMMMgMMIjMMIjMMIiMMEiMMQiMMQiMMMiMMMhMMMiMMQiMMMiMMMiMBIdQcEAAAAQdFJOUwAQIDBAUGBwgI+fr7/P3+8jGoKKAAAACXBIWXMAABcRAAAXEQHKJvM/AAABtUlEQVR4Xu3c23KCMABFUaOAIir8/9da21Opl4AHQuy0ez2aDNmDihkdXAEAgBRCUW53j6pC428R6raLadaalF0Vj7qoNC2v0Gj5qGPQ1JxqLT6g0dSMSi09qNTkbMLw60ra3K/7nRYesdf0XE5ad0Sr6ZmsteyH9vRAIxd5n8WNVu26+tlVoH+K817uC60aOR1Bg7nfi/3l4eklk6wbZDnIcrwva13Vh6ijVu06PXBHg1130gOPmv12wkfAyNYzja0We9mLO4S5zB1GkeNcXXifmaP79FS8ffWL26n5rA3Zj+3U0p5eYCIyZjkXCbLIcjhZQZ9bGThZAH6Xfvub1EGHn4osB1kOshxkOW6z6kruf1lxB9JmXb9/6b+x+eIOkPWJrB5Zw8hykOUgy0GWgywHWQ6yHGQ5yHKQ5SDLQZaDLAdZDrIcZDnIcpDlIMtBloMsB1kOshxkOchykOUgy0GWgywHWQ6yHLdZ/Y3weuCbO5A2K5k/mrXXcRKbm7XQzaa1Dj9V/1cGSV3foFMtcrvp/L9sCQvcb9pudPA5kr/qD86NpXGh1D8yJVGkOFUAAPwPq9UZoavV7JzUkcQAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.73500043d3542fe4a8eac9b42c1fb8a2.svg";
export { ForwardRef as ReactComponent };